import { E_GenereOmbrellone, E_MainLato } from "../Utils/enumerations";

let latiParaventi = {};

// Calcola la posizione, rotazione e scala dei paraventi 
export function generateParaventi(
  lunghezzaLato,
  larghezzaLato,
  altezza,
  configuration,
  paravento,
  ingresso,
  ombrelloniDet,
  genereOmbrelloni
  ) {
    const parArray = []; 
    const hasLato1 = configuration.find(item => item.lato.toString() === E_MainLato.Lato1.toString() && item.parav === true) ? true : false;
    const hasLato2 = configuration.find(item => item.lato.toString() === E_MainLato.Lato2.toString() && item.parav === true) ? true : false;
    const hasLato3 = configuration.find(item => item.lato.toString() === E_MainLato.Lato3.toString() && item.parav === true) ? true : false;
    const hasLato4 = configuration.find(item => item.lato.toString() === E_MainLato.Lato4.toString() && item.parav === true) ? true : false;
    latiParaventi = {
      hasLato1,
      hasLato2,
      hasLato3,
      hasLato4,
    }
  
  // Verifica i lati in cui generare i paraventi
  // LATO 1
  if (hasLato1 && ingresso.toString() === E_MainLato.Lato1.toString()) {
    placeParavento(E_MainLato.Lato1, larghezzaLato, lunghezzaLato, altezza, 0, paravento, parArray, true, ombrelloniDet, genereOmbrelloni);  
  }
  else if (hasLato1 && ingresso.toString() !== E_MainLato.Lato1.toString()) {
    placeParavento(E_MainLato.Lato1, larghezzaLato, lunghezzaLato, altezza, 0, paravento, parArray, false, ombrelloniDet, genereOmbrelloni);  
  }
  // LATO 2
  if (hasLato2 && ingresso.toString() === E_MainLato.Lato2.toString()) {     
    placeParavento(E_MainLato.Lato2, lunghezzaLato, larghezzaLato, altezza, Math.PI/2, paravento, parArray, true, ombrelloniDet, genereOmbrelloni);       
  }
  else if (hasLato2 && ingresso.toString() !== E_MainLato.Lato2.toString()) {
    placeParavento(E_MainLato.Lato2, lunghezzaLato, larghezzaLato, altezza, Math.PI/2, paravento, parArray, false, ombrelloniDet, genereOmbrelloni);      
  }
  // LATO 3
  if (hasLato3 && ingresso.toString() === E_MainLato.Lato3.toString()) {
    placeParavento(E_MainLato.Lato3, larghezzaLato, lunghezzaLato, altezza, 0, paravento, parArray, true, ombrelloniDet, genereOmbrelloni);       
  }
  else if (hasLato3 && ingresso.toString() !== E_MainLato.Lato3.toString()) {
    placeParavento(E_MainLato.Lato3, larghezzaLato, lunghezzaLato, altezza, 0, paravento, parArray, false, ombrelloniDet, genereOmbrelloni);     
  }
  // LATO 4
  if (hasLato4 && ingresso.toString() === E_MainLato.Lato4.toString()) { 
    placeParavento(E_MainLato.Lato4, lunghezzaLato, larghezzaLato, altezza, Math.PI/2 ,paravento, parArray, true, ombrelloniDet, genereOmbrelloni);       
  }
  else if (hasLato4 && ingresso.toString() !== E_MainLato.Lato4.toString()) {
    placeParavento(E_MainLato.Lato4, lunghezzaLato, larghezzaLato, altezza, Math.PI/2 ,paravento, parArray, false, ombrelloniDet, genereOmbrelloni);    
  }
  return parArray;
}

// Per ogni lato selezionato genera i paraventi (1 fila se non c'è ingresso, 2 file se c'è ingresso)
const placeParavento = (lato, direzionePrincipale, direzioneSecondaria, altezza, rotationY, paravento, parArray, hasIngresso, ombrelloniDet, genereOmbrelloni) => {  
  // Se non ha ingresso, crea un paravento principale e un pezzettino
  if (!hasIngresso) {
    createPiece(lato, -direzionePrincipale/2, direzionePrincipale/2, 1, direzioneSecondaria, altezza, rotationY, paravento, parArray, hasIngresso);
  }  
  // Se non sono ancora stati selezionati ombrelloni
  else if (hasIngresso && (ombrelloniDet.dataOmbrelloni.length === 0 || !ombrelloniDet.isVisible)) { 
    createPiece(lato, -direzionePrincipale/2, -0.5, 1, direzioneSecondaria, altezza, rotationY, paravento, parArray, hasIngresso);
    createPiece(lato, direzionePrincipale/2, 0.5, -1, direzioneSecondaria, altezza, rotationY, paravento, parArray, hasIngresso);  
  } 
  else if (hasIngresso && ombrelloniDet.dataOmbrelloni.length > 0 && genereOmbrelloni.toString() === E_GenereOmbrellone.Centrale.toString()) {
    createPiece(lato, -direzionePrincipale/2, -0.5, 1, direzioneSecondaria, altezza, rotationY, paravento, parArray, hasIngresso);
    createPiece(lato, direzionePrincipale/2, 0.5, -1, direzioneSecondaria, altezza, rotationY, paravento, parArray, hasIngresso);
  }
  // Se ha ingresso, crea due paraventi principali e due pezzettini
  else if (hasIngresso && ombrelloniDet.dataOmbrelloni.length > 0 && (genereOmbrelloni.toString() === E_GenereOmbrellone.Braccio.toString() || genereOmbrelloni.toString() === E_GenereOmbrellone.Sbalzo.toString())) {
    // Nel caso ci siano gli ombrelloni sui lati giusti
    if (ombrelloniDet && ombrelloniDet.isVisible && ombrelloniDet.dataOmbrelloni.length > 0 && (lato.toString() === E_MainLato.Lato1.toString() || lato.toString() === E_MainLato.Lato3.toString())) {
      if (ombrelloniDet.latoOmbrelloni.toString() === E_MainLato.Lato4.toString()) {      
        createPiece(lato, -direzionePrincipale/2, direzionePrincipale/2 - ombrelloniDet.dataOmbrelloni[0].secondaryDimension/2 - 0.5, 1, direzioneSecondaria, altezza, rotationY, paravento, parArray, hasIngresso);
        createPiece(lato, direzionePrincipale/2, direzionePrincipale/2 - ombrelloniDet.dataOmbrelloni[0].secondaryDimension/2 + 0.5, -1, direzioneSecondaria, altezza, rotationY, paravento, parArray, hasIngresso);
      } else if (ombrelloniDet.latoOmbrelloni.toString() === E_MainLato.Lato2.toString()) {
        createPiece(lato, direzionePrincipale/2, -direzionePrincipale/2 + ombrelloniDet.dataOmbrelloni[0].secondaryDimension/2 + 0.5, -1, direzioneSecondaria, altezza, rotationY, paravento, parArray, hasIngresso);
        createPiece(lato, -direzionePrincipale/2, -direzionePrincipale/2 + ombrelloniDet.dataOmbrelloni[0].secondaryDimension/2 - 0.5, 1, direzioneSecondaria, altezza, rotationY, paravento, parArray, hasIngresso);
      }  // Nel caso non ci siano ombrelloni su quei lati
      else {
        createPiece(lato, -direzionePrincipale/2, -0.5, 1, direzioneSecondaria, altezza, rotationY, paravento, parArray, hasIngresso);
        createPiece(lato, direzionePrincipale/2, 0.5, -1, direzioneSecondaria, altezza, rotationY, paravento, parArray, hasIngresso);
      } 
    }
    else if (ombrelloniDet && ombrelloniDet.isVisible && ombrelloniDet.dataOmbrelloni.length > 0 && (lato.toString() === E_MainLato.Lato2.toString() || lato.toString() === E_MainLato.Lato4.toString())) {
      if (ombrelloniDet.latoOmbrelloni.toString() === E_MainLato.Lato3.toString()) {      
        createPiece(lato, -direzionePrincipale/2, direzionePrincipale/2 - ombrelloniDet.dataOmbrelloni[0].secondaryDimension/2 - 0.5, 1, direzioneSecondaria, altezza, rotationY, paravento, parArray, hasIngresso);
        createPiece(lato, direzionePrincipale/2, direzionePrincipale/2 - ombrelloniDet.dataOmbrelloni[0].secondaryDimension/2 + 0.5, -1, direzioneSecondaria, altezza, rotationY, paravento, parArray, hasIngresso);
      } else if (ombrelloniDet.latoOmbrelloni.toString() === E_MainLato.Lato1.toString()) {
        createPiece(lato, direzionePrincipale/2, -direzionePrincipale/2 + ombrelloniDet.dataOmbrelloni[0].secondaryDimension/2 + 0.5, -1, direzioneSecondaria, altezza, rotationY, paravento, parArray, hasIngresso);
        createPiece(lato, -direzionePrincipale/2, -direzionePrincipale/2 + ombrelloniDet.dataOmbrelloni[0].secondaryDimension/2 - 0.5, 1, direzioneSecondaria, altezza, rotationY, paravento, parArray, hasIngresso);
      }  else {
        createPiece(lato, -direzionePrincipale/2, -0.5, 1, direzioneSecondaria, altezza, rotationY, paravento, parArray, hasIngresso);
        createPiece(lato, direzionePrincipale/2, 0.5, -1, direzioneSecondaria, altezza, rotationY, paravento, parArray, hasIngresso);
      } 
    }   
  } 
};

// Crea pezzi interi
const createPiece = (lato, origin, end, verso, direzioneSecondaria, altezza, rotationY, paravento, parArray, hasIngresso) => {
  const tNumbPrincipal = Math.abs(end-origin) / paravento.meshMaxScale;
  const rNumbPrincipal = Math.floor(tNumbPrincipal);
  const partialParavento = (tNumbPrincipal % rNumbPrincipal).toFixed(2);  
  let posX;
  let posZ;  
  // Piazza paraventi interi 
  for (let i = 0; i < rNumbPrincipal; i++) {    
    switch(lato.toString()) {
      case E_MainLato.Lato1.toString() : {
        posX = -direzioneSecondaria / 2;       
        posZ = verso === 1 ? origin + (paravento.meshMaxScale * i) : origin - (paravento.meshMaxScale * i + paravento.meshMaxScale);   
      }      
      break;
      case E_MainLato.Lato2.toString() : {
        posX = verso === 1 ? origin + (paravento.meshMaxScale * i) : origin - (paravento.meshMaxScale * i + paravento.meshMaxScale);
        posZ = -direzioneSecondaria / 2;
      }
      break;
      case E_MainLato.Lato3.toString() : {        
        posX = direzioneSecondaria / 2;
        posZ = verso === 1 ? origin + (paravento.meshMaxScale * i) : origin - (paravento.meshMaxScale * i + paravento.meshMaxScale);   
      }
      break;   
      case E_MainLato.Lato4.toString() : {
        posX = verso === 1 ? origin + (paravento.meshMaxScale * i) : origin - (paravento.meshMaxScale * i + paravento.meshMaxScale);
        posZ = direzioneSecondaria / 2;
      } 
      default:
        E_MainLato.Lato1.toString()
      break;
    }
    parArray.push({
      pos: [
        posX,
        altezza,
        posZ,
      ],
      rot: [0, rotationY, 0],
      sc: [
        paravento.meshScale[0],
        paravento.meshScale[1],
        paravento.meshMaxScale * paravento.percOffset,
      ],
    });
  }
  // Crea i pezzettini
  createSmallPiece(parArray, hasIngresso, partialParavento, paravento, tNumbPrincipal, end, direzioneSecondaria, lato, verso, altezza, rotationY);
}

// Crea un pezzo piccolo
const createSmallPiece = (parArray, hasIngresso, partialParavento, paravento, tNumbPrincipal, end, direzioneSecondaria, lato, verso, altezza, rotationY) => {
  let partialL;
  if (hasIngresso) {
    if (isNaN(partialParavento)) {   
      partialL = tNumbPrincipal * paravento.percOffset;
    } else {
      partialL = partialParavento * paravento.percOffset;
    }
  }
  let posX;
  let posZ;
  if (partialParavento !== 0) {
    switch(lato.toString()) {    
      case E_MainLato.Lato1.toString() : {
        posX = -direzioneSecondaria / 2;
        posZ = verso === 1 ? end - partialParavento : end; 
        if (isNaN(partialParavento)) {   
          posZ = verso === 1 ? end - tNumbPrincipal : end; 
        } 
      }
      break;
      case E_MainLato.Lato2.toString() : {
        posX = verso === 1 ? end - partialParavento : end;
        posZ = -direzioneSecondaria / 2;
        if (isNaN(partialParavento)) {   
          posX = verso === 1 ? end - tNumbPrincipal : end; 
        } 
      }
      break;
      case E_MainLato.Lato3.toString() : {
        posX = direzioneSecondaria / 2;
        posZ = verso === 1 ? end - partialParavento : end;
        if (isNaN(partialParavento)) {   
          posZ = verso === 1 ? end - tNumbPrincipal : end; 
        } 
      }
      break;
      case E_MainLato.Lato4.toString() : {
        posX = verso === 1 ? end - partialParavento : end;
        posZ = direzioneSecondaria / 2;
        if (isNaN(partialParavento)) {   
          posX = verso === 1 ? end - tNumbPrincipal : end; 
        } 
      }
      break;
    }
    parArray.push({
      pos: [
        posX,
        altezza,
        posZ
      ],
      rot: [0, rotationY, 0],
      sc: [
        paravento.meshScale[0],
        paravento.meshScale[1],
        !hasIngresso ? partialParavento * paravento.percOffset : partialL,
      ],
    });
  }
}

export const getLatiParaventi = () => {
  return latiParaventi;
}